class ReleasePopup extends HTMLElement {
  constructor() {
    super();

    this.articleTitle = this.dataset.articleTitle || '';
    this.releaseStart = this.dataset.releaseStart || '';
    this.releaseEnd = this.dataset.releaseEnd || '';
  }

  connectedCallback() {
    if (!this.releaseStart || !this.releaseEnd) return;

    this.setupGoogleLink();
    this.setupAppleLink();
  }

  setupGoogleLink() {
    const link = this.querySelector('[data-calendar="google"]');
    if (!link) return;

    const startDate = new Date(this.releaseEnd);
    const endDate = new Date(this.releaseStart);

    const dateUrlStart = startDate.toISOString().replace(/-/g, '').replace(/:/g, '').replace(/\./g, '');
    const dateUrlEnd = endDate.toISOString().replace(/-/g, '').replace(/:/g, '').replace(/\./g, '');

    const url =
      'https://calendar.google.com/calendar/render?action=TEMPLATE' +
      '&dates=' + dateUrlEnd + '/' + dateUrlStart +
      '&location=' + window.location.origin +
      '&text=' + this.articleTitle +
      '&details=' + window.location.href;

    link.setAttribute('href', encodeURI(url));
    link.setAttribute('target', '_blank');
  }

  setupAppleLink() {
    const link = this.querySelector('[data-calendar="apple"]');
    if (!link) return;

    link.addEventListener('click', (e) => {
      e.preventDefault();
      if (!window.ics) return;

      link.classList.add('loading');

      const cal = window.ics();
      cal.addEvent(
        this.articleTitle,
        window.location.href,
        window.location.href,
        this.releaseStart,
        this.releaseEnd
      );

      cal.download('deadstock-ca-apple-event');
      link.classList.remove('loading');
    });
  }
}

customElements.define('release-popup', ReleasePopup);
